module.exports = __webpack_public_path__ + "img/applogo2.4064071a.svg";